import { useState } from "react";
import SearchIcon from "../Icons/SearchIcon";
import FilterIcon from "../Icons/FilterIcon";
import { DateRangePicker } from "rsuite";
import FilterSidebar from "./FilterSidebar";
import DownloadIcon from "../Icons/DownloadIcon";
import * as XLSX from "xlsx";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { useSelector } from "react-redux";
import SearchSelectBox from "./SearchSelectBox";
import { callApi } from "../../ApiHelper/ApiHelper";
import { updateFiltersStates } from "../../store/actions/UserActions";
import store from "../../store";
import SearchSiteSelect from "./SiteSearchSelect";
import RefreshIcon from "../Icons/RefreshIcon";

export default function FilterComponent({
  handleRefresh,
  filterArray,
  monthFilter,
  handleFilterForLeave,
  handleFilterForAttendance,
  handleSearch,
  searchPlaceHolder,
  leaveList,
  sortHandler = () => { },
  handleData,
  attendanceList,
  pageStates,
  handleImport = null,
  handleExport = null,
  handleDownloadPA,
  isShowVendorFilter = false,
  hideAllSiteOption,
  orderByHandler,
  orderByList,
  orderByStatus,
  orderByStatusList,
  dueHandler,
  dueList,
  setPageState = () => { },
  getSite = () => Promise.resolve([]),
  getCompany = () => Promise.resolve([]),
  getExpense = null,
  getUser = null,
  expenseMonthFilter = false,
}) {
  const [isShow, setIsShow] = useState(false);
  const [state, setState] = useState({
    vendorList: [],
    vendorId: "",
    vendorIsLoading: false,
  });
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const toggle = () => {
    setIsShow((pre) => !pre);
  };

  const fetchVendorList = (inputValue) => {
    return new Promise((resolve) => {
      // Ensure `state.reqType` is captured correctly
      const site = state?.siteId || "";
      let API = `${apiUrl.get_vendor}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      // Start Loading
      setState((prev) => ({
        ...prev,
        vendorIsLoading: true,
      }));

      // API Call
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            //  console.log("responce====>",response?.data?.purchase);
            const formattedData = response?.data?.vendor.map((purchase) => ({
              value: purchase.id,
              label: purchase.firmName,
            }));

            setState((prev) => ({
              ...prev,
              vendorIsLoading: false,
              vendorList: response?.data?.vendor,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const handleSearchChange = (data, type) => {
    // console.log("Selected Data:", data);
    setPageState((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type == "companyId" && {
        // companyId: data?.companyId,
        siteId: "",
      }),
    }));
    store.dispatch(
      updateFiltersStates({
        [type]: data?.value,
      })
    );

  };


  return (
    <>
      <div
        className={`table-head d-flex flex-wrap align-items-center justify-content-end mb-4 border-bottom pb-2 gap-3`}
      >
        {handleSearch && (
          <div className="position-relative me-auto">
            <span className="search-icon">
              <SearchIcon />
            </span>
            <input
              type="text"
              className="form-control search-control"
              style={{ minWidth: "16rem" }}
              id="searchUsers"
              placeholder={searchPlaceHolder ? searchPlaceHolder : "Search"}
              onChange={handleSearch}
            />
          </div>
        )}

        {attendanceList && (
          <div className="d-flex align-items-center gap-3">
            <select
              className="form-select min-w-20 pe-5"
              aria-label="Default select "
              onChange={(e) => {
                const data = {
                  attendanceStatus: e.target.value,
                };
                handleFilterForAttendance(data);
              }}
            // defaultValue={leaveList[0]?.id}
            >
              <option value={""} className="d-none">
                Select Attendance Status
              </option>
              {attendanceList &&
                attendanceList.length > 0 &&
                attendanceList.map((item, i) => {
                  return (
                    <option value={item?.value} key={i}>
                      {item?.label}
                    </option>
                  );
                })}
            </select>
          </div>
        )}
        {/* Removed inner grouping div to allow fluid flex wrapping */}
        {isShowVendorFilter && (
          <div className="position-relative">
            <SearchSelectBox
              value={filterDetails?.vendorId}
              onChange={(option) => handleSearchChange(option, "vendorId")}
              fetchOptions={fetchVendorList}
              loading={state?.vendorIsLoading}
              isAsync={true}
              defaultFetch={"defaultFetch"}
              title={"Search Vendor"}
              isUsingFilter={true}
            />
          </div>
        )}

        {dueHandler && (
          <div className="d-flex align-items-center">
            <select
              className="form-select pe-5"
              style={{ cursor: "pointer" }}
              onChange={dueHandler}
              value={filterDetails?.due ?? ""}
            >
              {dueList &&
                dueList?.length > 0 &&
                dueList?.map((item, index) => (
                  <option key={index} value={item?.value}>
                    {item?.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {filterArray?.companyList && (
          <SearchSiteSelect
            style={{ minWidth: "16rem" }}
            value={filterDetails?.companyId}
            options={pageStates?.companyList}
            onSelect={(value) => {
              const data = {
                companyId: value?.value,
              };
              handleData(data, "companyId");
            }}
            onSearch={(input) => getCompany(input)}
            isLoading={pageStates?.isLoadingCompany}
            placeholder={"Select Company"}
          />
        )}

        {getExpense && (
          <SearchSiteSelect
            style={{ minWidth: "16rem" }}
            value={filterDetails?.expenseHeadId}
            options={pageStates?.expenseHeadList}
            onSelect={(value) => {
              const data = {
                expenseHeadId: value?.value,
              };
              handleData(data, "expenseHeadId");
            }}
            onSearch={(input) => getExpense(input)}
            isLoading={false}
            placeholder={"Select Expense Name"}
            showClearButton={true}
          />
        )}

        {getUser && (
          <SearchSiteSelect
            style={{ minWidth: "16rem" }}
            value={filterDetails?.createdById}
            options={pageStates?.createdByList}
            onSelect={(value) => {
              const data = {
                createdById: value?.value,
              };
              handleData(data, "createdById");
            }}
            onSearch={(input) => getUser(input)}
            isLoading={false}
            placeholder={"Select Created By"}
            showClearButton={true}
          />
        )}

        {expenseMonthFilter && (
          <div className="d-flex align-items-center">
            <select
              className="form-select pe-5"
              style={{ cursor: "pointer" }}
              onChange={(e) => {
                store.dispatch(
                  updateFiltersStates({
                    expenseMonth: e.target.value,
                  })
                );
              }}
              value={filterDetails?.expenseMonth ?? ""}
            >
              <option value="">All Expense Month</option>
              <option value={`january`}>January</option>
              <option value={`february`}>February</option>
              <option value={`march`}>March</option>
              <option value={`april`}>April</option>
              <option value={`may`}>May</option>
              <option value={`june`}>June</option>
              <option value={`july`}>July</option>
              <option value={`august`}>August</option>
              <option value={`september`}>September</option>
              <option value={`october`}>October</option>
              <option value={`november`}>November</option>
              <option value={`december`}>December</option>
            </select>
          </div>
        )}

        {filterArray?.autoSiteSelector && filterArray?.autoSiteSelector()}

        {filterArray?.site && (
          <SearchSiteSelect
            style={{ minWidth: "16rem" }}
            value={filterArray?.site?.find((item) => item?.value === pageStates?.siteId)?.value}
            options={filterArray?.site}
            onSelect={(value) => {
              // console.log(value)
              const data = {
                site: value?.value,
              };
              handleData(data, "site");
            }}
            onSearch={(input) => getSite(
              filterDetails?.companyId ||
              pageStates?.companyId ||
              null,
              input
            )}
            isLoading={pageStates?.isLoadingSite}
            placeholder={"Select Site"}
            showClearButton={filterArray?.isClearButton === false ? false : true}
          />
        )}

        {filterArray?.office && (
          <div className="d-flex align-items-center gap-3">
            <select
              className="form-select min-w-20 pe-5"
              id="typ"
              onChange={(e) => {
                const data = {
                  office: e.target.value,
                };
                handleData(data, "site");
              }}
              value={pageStates?.officeName}
            >
              {/* {console.log(filterArray?.office)} */}
              <option value={""} className="d-none">
                Select Offices
              </option>
              {filterArray?.office?.length !== 0 ? (
                <option value={""}>All Offices</option>
              ) : (
                <option disabled>No Offices found</option>
              )}
              {filterArray?.office?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
          </div>
        )}
        {orderByStatus && (
          <div className="d-flex align-items-center">
            <select
              className="form-select pe-5"
              style={{ cursor: "pointer" }}
              onChange={orderByStatus}
              value={pageStates?.status ?? ""}
            >
              {orderByStatusList &&
                orderByStatusList?.length > 0 &&
                orderByStatusList?.map((item, index) => (
                  <option key={index} value={item?.value}>
                    {item?.name}
                  </option>
                ))}
            </select>
          </div>
        )}
        {orderByHandler && (
          <div className="d-flex align-items-center">
            <select
              className="form-select pe-5"
              style={{ cursor: "pointer" }}
              onChange={orderByHandler}
              value={filterDetails?.orderBy ?? ""}
            >
              {orderByList &&
                orderByList?.length > 0 &&
                orderByList?.map((item, index) => (
                  <option key={index} value={item?.value}>
                    {item?.name}
                  </option>
                ))}
            </select>
          </div>
        )}

        {monthFilter && <input type="month" className="form-control" />}
        {handleImport && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleImport}
          >
            Import
          </button>
        )}
        {handleExport && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleExport}
          >
            Export
          </button>
        )}
        {handleRefresh && (
          <button
            type="button"
            className="btn btn-outline-primary filter-btn"
            onClick={handleRefresh}
            title="Recalculate Due Days"
          >
            <RefreshIcon />
          </button>
        )}

        {handleDownloadPA && (
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleDownloadPA}
          >
            Download
          </button>
        )}

        {filterArray && !filterArray?.isShow && (
          <div className="d-flex align-items-stretch justify-content-end gap-3">
            <button
              className="btn btn-outline-primary filter-btn"
              onClick={() => toggle()}
            >
              <FilterIcon />
            </button>
          </div>
        )}
        {handleFilterForLeave && (
          <div className="d-flex gap-3">
            <div className="d-flex align-items-center gap-3">
              <select
                className="form-select min-w-20 pe-5"
                aria-label="Default select "
                onChange={(e) =>
                  handleFilterForLeave((pre) => ({
                    ...pre,
                    leaveType: e.target.value,
                  }))
                }
              >
                <option value={""} className="d-none">
                  Select Leave Type
                </option>
                {leaveList &&
                  leaveList.length > 0 &&
                  leaveList.map((item, i) => {
                    return (
                      <option value={item?.leaveType} key={i}>
                        {item?.leaveType}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
        )}
        {/* {payList && (
            <>
              <div className="d-flex align-items-center gap-3">
                <select
                  className="form-select min-w-20 pe-5"
                  id="typ"
                  onChange={(e) => {
                    const data = {
                      payList: e.target.value,
                    };
                    handleData(data, "site");
                  }}
                // value={pageStates?.siteId}
                >
                  {payList &&
                    payList?.length > 0 &&
                    payList?.map((item) => {
                      return (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                </select>
              </div>
            </>
          )} */}
        {/* Inner group div was removed */}
        {/* 
        {handleDownloadPaySlip && (
          <div className="d-flex align-items-stretch justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleDownloadPaySlip}
            >
              Download Pay Slip
            </button>
          </div>
        )} */}
      </div>

      <FilterSidebar
        isOpen={isShow}
        toggle={toggle}
        sortHandler={sortHandler}
        sortList={filterArray}
      />
    </>
  );
}
